<ng-container *ngIf="!control?.pristine &&
                    control?.hasError('maxlength')">
    {{ 'asset_primary_value_max_warning' | translate:control?.getError('maxlength') }}
</ng-container>
<ng-container *ngIf="!control?.pristine &&
                    control?.hasError('username.maxlength')">
    {{ 'asset_primary_username_max_warning'| translate:control?.getError('username.maxlength') }}
</ng-container>
<ng-container *ngIf="!control?.pristine &&
                    control?.hasError('regex')">
    {{ 'asset_primary_integer_warning' | translate }}
</ng-container>
<ng-container *ngIf="!control?.pristine &&
                    !control?.hasError('regex') &&
                    control?.hasError('range')">
    {{ 'asset_primary_value_range_warning' | translate:control?.getError('range') }}
</ng-container>
